import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const PreviewContainer = styled.div`
    position: relative;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
    padding: 16px;
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const FloatingDownloadButton = styled.a`
    position: absolute;
    z-index: 1;
    top: 16px;
    left: 16px;

    > button {
        background-color: ${colorsPalettes.carbon[0]};
    }
`;

export const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    animation: media-preview-fade-in 0.3s ease-in;

    @keyframes media-preview-fade-in {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export const VideoContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const PreviewVideo = styled.video`
    max-width: 100%;
    max-height: 100%;
    animation: media-preview-fade-in 0.3s ease-in;

    &::-webkit-media-controls-current-time-display,
    &::-webkit-media-controls-time-remaining-display {
        font-size: 14px;
    }
`;

export const PlayPauseOverlay = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    z-index: 10;
    pointer-events: none;

    @keyframes media-preview-fade-in-out {
        0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.8);
        }
        20% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
        80% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
        100% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(1.1);
        }
    }

    animation: media-preview-fade-in-out 0.6s ease-in-out;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, ${colorsPalettes.carbon[25]} 0%, ${colorsPalettes.carbon[50]} 100%);
`;
